// extracted by mini-css-extract-plugin
module.exports = {"card":"OneDog_card__243Wo","img":"OneDog_img__3oT-v","name":"OneDog_name__3RShH","text":"OneDog_text__hDrrs","click":"OneDog_click__1Fu4C","error":"OneDog_error__3DYFw"};